import React, { createElement, useEffect, useCallback, forwardRef } from 'react';
import { Select } from '@alifd/next';
import request from '@/utils/request';
const EntityList = ({ value, onChange, ...restProps }, ref) => {
    const [dataSource, setDataSource] = React.useState([]);
    const queryList = useCallback(async () => {
        const { content = [] } = await request.get('/api/exchange/entity/summary');
        const data = content?.map(({ name, code }) => {
            return {
                label: `${name}(${code})`,
                value: code,
            };
        });
        setDataSource(data);
    }, []);
    useEffect(() => {
        queryList();
    }, [queryList]);
    const renderPreview = () => {
        const val = dataSource.find((item) => item.value === value)?.label;
        return createElement("span", null, val);
    };
    return (createElement(Select, { ...restProps, value: value, showSearch: true, hasClear: true, ref: ref, dataSource: dataSource, renderPreview: renderPreview, onChange: onChange }));
};
export const EntityListRef = forwardRef(EntityList);
export default EntityListRef;
